import * as React from "react";
import { RouteComponentProps } from "@reach/router";
import { Bookings } from "../bookings/Bookings";

export class BookingsScreen extends React.PureComponent<RouteComponentProps> {
  render() {
    return <Bookings />;
  }
}
